import React, { useState, useEffect } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import "./bookDescriptionManual.scss";

interface DescriptionObj {
  descripcion: string;
}

interface BookDescriptionManualProps {
  description: string;
  subjectsList: Array<DescriptionObj>;
  descriptionEvent: any;
}

const BookDescription = (props: BookDescriptionManualProps) => {
  const [subjects, setSubjects] = useState<Array<string>>([]);

  useEffect(() => {
    if (props.subjectsList) {
      let auxSubjects = props.subjectsList.map(subject => (
        subject.descripcion
      ));
      setSubjects(auxSubjects);
    }
  }, [props.subjectsList]);

  return (
    <div className="o-book-desc-manual">
      <h2 className="o-book-desc-manual__title">Descripción</h2>
      <div className="o-book-desc-manual__columns">
        <div className="o-book-desc-manual__left">
          <p className="o-book-desc-manual__left__description">
            {props.description || "Muy pronto te contaremos más sobre este título."}
          </p>
          {subjects.length > 0 &&
            <>
            <p className="o-book-desc-manual__left__subjects-title">
              Materias
            </p>
            <ul className="o-book-desc-manual__left__subjects-items">
              {subjects.slice(0, 10).map((subject, index) => 
                <li className="o-book-desc-manual__left__subjects-items__item" key={index}>
                  {subject}
                </li>
              )}
            </ul>
            </>
          }
        </div>
        <div className="o-book-desc-manual__vertical-divider"></div>
        <div className="o-book-desc-manual__right">
          {documentToReactComponents(props.descriptionEvent)}
        </div>
      </div>
    </div>
  )
}

export default BookDescription;